// Ported verbatim from native/src/editor/activity/plugins/challenge/SurprisePartyFlow.js:153-165.

'use strict';

const {roleHasBlock, totalBlockCount} = require('./helpers');

function evaluate (activityData, simState) {
    const dogHasMessage = roleHasBlock(simState, 'dog', 'message');
    const bluuxHasOnmessage = roleHasBlock(simState, 'bluux', 'onmessage');
    const bluuxHasShow = roleHasBlock(simState, 'bluux', 'show');
    const catHasOnmessage = roleHasBlock(simState, 'cat', 'onmessage');
    const catHasShow = roleHasBlock(simState, 'cat', 'show');

    return {
        success: dogHasMessage && bluuxHasOnmessage && bluuxHasShow && catHasOnmessage && catHasShow,
        usedBlocks: totalBlockCount(simState),
        storyPhase: simState && simState.phaseFlags && simState.phaseFlags.storyPhase || null,
        flagTapCount: simState && simState.phaseFlags && simState.phaseFlags.flagTapCount || 0
    };
}

module.exports = evaluate;
